(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["se-gallery-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('se-gallery-text')) return;

    class SeGalleryText extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        if (document.readyState !== 'loading') this.init();
        else document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
      }

      init() {
        if (this.started) return;
        this.started = true;
        this.track = this.querySelector('[data-track]');
        this.thumb = this.querySelector('[data-thumb]');
        if (!this.track) return;
        const step = (dir) => {
          const slide = this.track.querySelector('.se-gt__slide');
          if (!slide) return;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          this.track.scrollBy({ left: dir * (slide.offsetWidth + gap), behavior: 'smooth' });
        };
        this.querySelector('[data-prev]')?.addEventListener('click', () => step(-1));
        this.querySelector('[data-next]')?.addEventListener('click', () => step(1));
        this.update = this.update.bind(this);
        this.track.addEventListener('scroll', this.update, { passive: true });
        window.addEventListener('resize', this.update);
        requestAnimationFrame(this.update);
      }

      update() {
        const t = this.track;
        const ratio = t.scrollWidth > 0 ? Math.min(1, t.clientWidth / t.scrollWidth) : 1;
        const span = t.scrollWidth - t.clientWidth;
        const pos = span > 0 ? t.scrollLeft / span : 0;
        if (this.thumb) {
          this.thumb.style.width = ratio * 100 + '%';
          this.thumb.style.transform = 'translateX(' + pos * (1 / ratio - 1) * 100 + '%)';
        }
        const prev = this.querySelector('[data-prev]');
        const next = this.querySelector('[data-next]');
        if (prev) prev.disabled = t.scrollLeft <= 2;
        if (next) next.disabled = t.scrollLeft >= span - 2;
        const controls = this.querySelector('.se-gt__controls');
        if (controls) controls.hidden = ratio >= 0.999;
      }
    }

    customElements.define('se-gallery-text', SeGalleryText);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["se-notification-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const calm = window.matchMedia('(prefers-reduced-motion: reduce)');

    const start = (bar) => {
      if (bar.seNotice) return;
      const items = ['center', 'left', 'right']
        .map((k) => bar.querySelector(`.se-notice__item--${k}:not(.se-notice__item--empty)`))
        .filter(Boolean);
      if (items.length < 2) return;
      const every = Math.max(3000, Number(bar.dataset.interval) || 5000);
      let index = 0;
      let paused = false;
      const show = () => items.forEach((el, i) => el.classList.toggle('is-active', i === index));
      const tick = () => {
        if (paused || document.hidden) return;
        index = (index + 1) % items.length;
        show();
      };
      const sync = () => {
        const on = !calm.matches;
        bar.toggleAttribute('data-rotating', on);
        index = 0;
        show();
      };
      bar.addEventListener('pointerenter', () => (paused = true));
      bar.addEventListener('pointerleave', () => (paused = false));
      bar.addEventListener('pointerdown', () => (paused = true));
      bar.addEventListener('focusin', () => (paused = true));
      bar.addEventListener('focusout', () => (paused = false));
      calm.addEventListener('change', sync);
      sync();
      bar.seNotice = setInterval(() => !calm.matches && tick(), every);
    };

    const init = () => document.querySelectorAll('[data-se-notice]').forEach(start);
    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["se-pairings"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('se-pairings')) return;

    const signed = (v) => (v < 0 ? '−' : v > 0 ? '+' : '') + Math.abs(v) + '°';
    const kind = (type) => {
      const v = String(type || '').toLowerCase();
      if (v === 'west' || v.includes('vest') || v.includes('gilet')) return 'vest';
      if (v.includes('short')) return 'shorts';
      if (v.includes('jacket') || v.includes('coat') || v.includes('parka')) return 'jacket';
      return 'other';
    };
    const esc = (t) => String(t ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);

    class SePairings extends HTMLElement {
      async connectedCallback() {
        const d = this.dataset;
        let all = [];
        try {
          const html = await fetch(d.url).then((r) => (r.ok ? r.text() : ''));
          const doc = new DOMParser().parseFromString(html, 'text/html');
          all = JSON.parse(doc.querySelector('[data-se-candidates]')?.textContent || '[]');
        } catch (e) {
          return;
        }

        const min = +d.min;
        const max = +d.max;
        const mine = kind(d.type);
        const genders = (d.gender || '').split(',').filter(Boolean);
        const count = +d.count || 4;

        /* One entry per model: in stock, same gender, prefer the same colour name as this product */
        const byModel = new Map();
        all.forEach((c) => {
          if (!c.available || c.model === d.model) return;
          if (genders.length && c.gender && !c.gender.split(',').some((g) => genders.includes(g))) return;
          const prev = byModel.get(c.model);
          if (!prev || (c.color === d.color && prev.color !== d.color)) byModel.set(c.model, c);
        });
        const pool = [...byModel.values()];
        const used = new Set();
        const take = (list, n, label) =>
          list
            .filter((c) => !used.has(c.model))
            .slice(0, n)
            .map((c) => (used.add(c.model), { c, label }));

        /* Pairs well with (picked first, so these specific roles get their best match) */
        let pair = [];
        const wantPairs = d.pairs === 'true';
        const vests = pool.filter((c) => kind(c.type) === 'vest');
        const jackets = pool.filter((c) => kind(c.type) === 'jacket');
        if (!wantPairs) {
          /* "Pairs well with" is switched off in the section settings */
        } else if (mine === 'jacket') {
          pair = pair.concat(take(vests.slice().sort((a, b) => a.min - b.min), 2, d.labelLayer));
          pair = pair.concat(take(jackets.filter((c) => c.min < min).sort((a, b) => b.min - a.min), 1, d.labelColder));
          pair = pair.concat(take(jackets.filter((c) => c.max > max).sort((a, b) => a.max - b.max), 1, d.labelMilder));
        } else if (mine === 'vest') {
          /* Light jackets that a vest makes warmer: the lightest ones that still reach this vest's range */
          pair = take(jackets.filter((c) => c.min <= max && c.max >= min).sort((a, b) => b.max - a.max || b.min - a.min), count, d.labelOver);
        }

        /* Alternatives: same kind, closest temperature range (overlapping at least half of this one) */
        const distance = (c) => Math.abs(c.min - min) + Math.abs(c.max - max);
        const same = pool.filter((c) => kind(c.type) === mine).sort((a, b) => distance(a) - distance(b));
        const overlap = (c) => Math.min(c.max, max) - Math.max(c.min, min);
        let alt = take(same.filter((c) => overlap(c) >= Math.max(1, (max - min) / 2)), count, '');
        /* Fill a full row when possible (a half-empty row looks unfinished): any overlap, then the nearest */
        if (alt.length < count) alt = alt.concat(take(same.filter((c) => overlap(c) > 0), count - alt.length, ''));
        if (alt.length < count) alt = alt.concat(take(same, count - alt.length, ''));

        this.fill('alt', alt);
        this.fill('pair', pair);
        if (alt.length || pair.length) this.hidden = false;
      }

      fill(name, items) {
        const row = this.querySelector(`[data-row="${name}"]`);
        if (!row || !items.length) return;
        const grid = row.querySelector('[data-grid]');
        grid.innerHTML = items
          .map(({ c, label }) => {
            const img = c.card || c.image;
            return `<li class="se-pair__item"><a class="se-pair__card" href="${esc(c.url)}">
              <span class="se-pair__media">${img ? `<img src="${esc(img)}" alt="${esc(c.title)}" loading="lazy" width="700" height="1050">` : ''}</span>
              <span class="se-pair__text">
                ${label ? `<span class="se-pair__label">${esc(label)}</span>` : ''}
                <span class="se-pair__name">${esc(c.title)}</span>
                <span class="se-pair__price">${c.compare ? `<s>${esc(c.compare)}</s>` : ''}${esc(c.price || '')}</span>
                <span class="se-pair__range">${signed(c.min)} to ${signed(c.max)}</span>
              </span></a></li>`;
          })
          .join('');
        row.hidden = false;

        const thumb = row.querySelector('.se-pair__progress span');
        const update = () => {
          const ratio = grid.scrollWidth > 0 ? Math.min(1, grid.clientWidth / grid.scrollWidth) : 1;
          const span = grid.scrollWidth - grid.clientWidth;
          const pos = span > 0 ? grid.scrollLeft / span : 0;
          thumb.style.width = ratio * 100 + '%';
          thumb.style.transform = 'translateX(' + pos * (1 / ratio - 1) * 100 + '%)';
          thumb.parentElement.hidden = ratio >= 0.999;
        };
        grid.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        requestAnimationFrame(update);
      }
    }

    customElements.define('se-pairings', SePairings);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["se-split-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('se-hero-video')) {
    const MOBILE = window.matchMedia('(max-width: 749px)');

    class SeHeroVideo extends HTMLElement {
      connectedCallback() {
        this.render = this.render.bind(this);
        this.render();
        MOBILE.addEventListener('change', this.render);
      }

      disconnectedCallback() {
        MOBILE.removeEventListener('change', this.render);
      }

      render() {
        const want = MOBILE.matches ? 'mobile' : 'desktop';
        if (this.dataset.current === want) return;
        this.dataset.current = want;
        this.querySelector('video')?.remove();

        const tpl = this.querySelector(`template[data-se-video="${want}"]`);
        if (!tpl) return;
        const video = tpl.content.querySelector('video')?.cloneNode(true);
        if (!video) return;

        video.muted = true;
        video.setAttribute('muted', '');
        video.addEventListener('playing', () => video.classList.add('is-ready'), { once: true });
        this.append(video);
        const p = video.play?.();
        if (p && p.catch) {
          p.catch(() => {
            /* Autoplay refused (iPhone in Low Power Mode, data saver): keep the poster and
               start the film on the visitor's first tap or scroll, which browsers allow. */
            const retry = () => {
              ['touchstart', 'pointerdown', 'scroll', 'keydown'].forEach((e) => window.removeEventListener(e, retry));
              video.play?.()?.catch?.(() => {});
            };
            ['touchstart', 'pointerdown', 'scroll', 'keydown'].forEach((e) => window.addEventListener(e, retry, { passive: true, once: true }));
          });
        }
      }
    }

    customElements.define('se-hero-video', SeHeroVideo);
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["se-stockists"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('se-stockists')) return;

    const toRad = (d) => (d * Math.PI) / 180;
    const distance = (a, b) => {
      const dLat = toRad(b.lat - a.lat);
      const dLng = toRad(b.lng - a.lng);
      const h = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * Math.sin(dLng / 2) ** 2;
      return 6371 * 2 * Math.asin(Math.sqrt(h));
    };

    class SeStockists extends HTMLElement {
      connectedCallback() {
        this.t = JSON.parse(this.querySelector('[data-se-sl-i18n]').textContent);
        this.search = this.querySelector('[data-se-sl-search]');
        this.countries = [...this.querySelectorAll('[data-se-sl-country]')];
        this.stores = [...this.querySelectorAll('[data-se-sl-store]')];
        this.kind = 'all';
        this.opened = new Set(this.countries.filter((c) => c.open));

        this.search.addEventListener('input', () => this.filter());
        this.querySelectorAll('[data-se-sl-kind]').forEach((b) =>
          b.addEventListener('click', () => {
            this.kind = b.dataset.seSlKind;
            this.querySelectorAll('[data-se-sl-kind]').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
            this.filter();
          })
        );

        const near = this.querySelector('[data-se-sl-near]');
        if ('geolocation' in navigator) {
          near.hidden = false;
          near.addEventListener('click', () => this.locate(near));
        }
      }

      matches(li) {
        const q = this.search.value.trim().toLowerCase();
        const k = li.dataset.kind;
        const kindOk = this.kind === 'all' || k === 'mw' || k === this.kind;
        return kindOk && (!q || li.dataset.search.includes(q));
      }

      filter() {
        const q = this.search.value.trim();
        let total = 0;
        this.countries.forEach((c) => {
          let n = 0;
          c.querySelectorAll('[data-se-sl-store]').forEach((li) => {
            const ok = this.matches(li);
            li.hidden = !ok;
            if (ok) n++;
          });
          c.hidden = n === 0;
          c.querySelector('[data-se-sl-count]').textContent = n;
          // While searching, open every country with a match; afterwards restore what was open
          if (q) c.open = n > 0;
          else c.open = this.opened.has(c);
          total += n;
        });
        this.querySelector('[data-se-sl-empty]').hidden = total > 0;
        if (this.here) this.showNearest();
      }

      locate(button) {
        button.textContent = this.t.locating;
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            this.here = { lat: pos.coords.latitude, lng: pos.coords.longitude };
            button.textContent = this.t.near_me;
            this.showNearest();
          },
          () => {
            button.textContent = this.t.denied;
          },
          { timeout: 10000, maximumAge: 600000 }
        );
      }

      showNearest() {
        const box = this.querySelector('[data-se-sl-nearest]');
        const list = this.querySelector('[data-se-sl-nearest-list]');
        const picks = this.stores
          .filter((li) => li.dataset.lat && this.matches(li))
          .map((li) => ({ li, d: distance(this.here, { lat: +li.dataset.lat, lng: +li.dataset.lng }) }))
          .sort((a, b) => a.d - b.d)
          .slice(0, 6);
        list.innerHTML = '';
        picks.forEach(({ li, d }) => {
          const copy = li.cloneNode(true);
          copy.hidden = false;
          const km = document.createElement('p');
          km.className = 'se-sl__store-km';
          km.textContent = this.t.km.replace('{n}', d < 10 ? d.toFixed(1) : Math.round(d));
          copy.insertBefore(km, copy.children[1]);
          list.appendChild(copy);
        });
        box.hidden = picks.length === 0;
        if (picks.length) box.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    customElements.define('se-stockists', SeStockists);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["se-weather-picks"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('se-weather-picks')) return;

    // City list: [key, name, lat, lon, countries that start here]
    const CITIES = [
      ['oslo', 'Oslo', 59.9139, 10.7522, ['NO']],
      ['bergen', 'Bergen', 60.3913, 5.3221, []],
      ['trondheim', 'Trondheim', 63.4305, 10.3951, []],
      ['tromso', 'Tromsø', 69.6492, 18.9553, []],
      ['stockholm', 'Stockholm', 59.3293, 18.0686, ['SE']],
      ['gothenburg', 'Gothenburg', 57.7089, 11.9746, []],
      ['copenhagen', 'Copenhagen', 55.6761, 12.5683, ['DK', 'IS']],
      ['helsinki', 'Helsinki', 60.1699, 24.9384, ['FI', 'EE']],
      ['berlin', 'Berlin', 52.52, 13.405, ['DE', 'PL', 'CZ']],
      ['munich', 'Munich', 48.1351, 11.582, ['AT']],
      ['zurich', 'Zurich', 47.3769, 8.5417, ['CH']],
      ['amsterdam', 'Amsterdam', 52.3676, 4.9041, ['NL', 'BE', 'LU']],
      ['london', 'London', 51.5072, -0.1276, ['GB', 'IE']],
      ['paris', 'Paris', 48.8566, 2.3522, ['FR']],
      ['milan', 'Milan', 45.4642, 9.19, ['IT']],
      ['madrid', 'Madrid', 40.4168, -3.7038, ['ES', 'PT']],
      ['new-york', 'New York', 40.7128, -74.006, ['US', 'CA']],
      ['tokyo', 'Tokyo', 35.6762, 139.6503, ['JP']],
    ];
    const STORE_CITY = 'se-wx-city';
    const STORE_GENDER = 'se-wx-gender';
    const CACHE_MIN = 60;

    const store = {
      get(k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } },
      set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} },
    };

    const deg = (v) => {
      const r = Math.round(v);
      return (r < 0 ? '−' + Math.abs(r) : r > 0 ? '+' + r : '0') + '°';
    };

    // Wind chill (°C, wind in m/s); only meaningful when cold and windy
    const feelsLike = (t, ms) => {
      const kmh = ms * 3.6;
      if (t > 10 || kmh < 4.8) return t;
      const p = Math.pow(kmh, 0.16);
      return 13.12 + 0.6215 * t - 11.37 * p + 0.3965 * t * p;
    };

    const kindOf = (code) => {
      if (!code) return 'dry';
      if (code.includes('snow')) return 'snow';
      if (code.includes('sleet')) return 'sleet';
      if (code.includes('rain') || code.includes('drizzle')) return 'rain';
      if (code.includes('fog')) return 'fog';
      if (code.includes('cloudy')) return code.startsWith('partly') ? 'partly' : 'cloudy';
      return 'clear';
    };
    // Visible words come from the theme locales (se.weather.*), read from [data-se-wx-i18n] on first use
    let T = null;
    const t = (k, vars) => {
      if (!T) {
        try { T = JSON.parse(document.querySelector('[data-se-wx-i18n]').textContent); } catch (e) { T = {}; }
      }
      return String(T[k] || k).replace(/\{(\w+)\}/g, (m, v) => (vars && v in vars ? vars[v] : m));
    };
    // Local names for a few cities, e.g. "munich=München|zurich=Zürich"
    const cityName = (key, name) => {
      const hit = t('cities').split('|').find((x) => x.split('=')[0] === key);
      return hit ? hit.split('=')[1] : name;
    };
    const LABEL = new Proxy({}, { get: (o, k) => t(String(k)) });

    // Summarise the next 12 hours of a MET locationforecast/compact response
    const summarise = (json) => {
      const series = (json && json.properties && json.properties.timeseries) || [];
      const hours = series.slice(0, 12);
      if (!hours.length) return null;
      let tMin = Infinity, tNow = null, windMax = 0, precip = 0;
      const kinds = {};
      hours.forEach((h, i) => {
        const d = h.data.instant.details;
        if (i === 0) tNow = d.air_temperature;
        tMin = Math.min(tMin, d.air_temperature);
        windMax = Math.max(windMax, d.wind_speed || 0);
        const n1 = h.data.next_1_hours;
        if (n1) {
          precip += (n1.details && n1.details.precipitation_amount) || 0;
          const k = kindOf(n1.summary && n1.summary.symbol_code);
          kinds[k] = (kinds[k] || 0) + 1;
        }
      });
      const wetKind = ['snow', 'sleet', 'rain'].find((k) => kinds[k]);
      const nowCode = hours[0].data.next_1_hours && hours[0].data.next_1_hours.summary.symbol_code;
      const kind = wetKind && precip >= 0.3 ? wetKind : kindOf(nowCode);
      const feels = feelsLike(tMin, Math.min(windMax, 15));
      return { tNow, tMin, feels, windMax, precip, kind, wet: !!wetKind && precip >= 0.3, heavy: precip >= 3, windy: windMax >= 8 };
    };

    const score = (p, w) => {
      let s = 0;
      if (w.feels < p.min) s += (p.min - w.feels) * 1.5;
      if (w.feels > p.max) s += (w.feels - p.max) * 1.2;
      if (w.wet) s += Math.max(0, (w.heavy ? 10 : 8) - p.water) * 1.5;
      if (w.windy) s += Math.max(0, 8 - p.wind) * 1;
      s += Math.abs((p.min + p.max) / 2 - w.feels) * 0.05; // prefer the centre of the range
      return s;
    };

    const why = (p, w) => {
      const parts = [];
      if (p.water >= 10) parts.push(t('waterproof'));
      else if (w.wet && p.water >= 5) parts.push(t('water_resistant'));
      if (p.wind >= 10) parts.push(t('windproof'));
      else if (w.windy && p.wind >= 5) parts.push(t('wind_resistant'));
      parts.push(t('range', { min: deg(p.min), max: deg(p.max) }));
      return parts.join(' · ');
    };

    const advice = (w) => {
      const f = w.feels;
      const warmth = t('warmth_' + (f < -10 ? 1 : f < 0 ? 2 : f < 10 ? 3 : f < 17 ? 4 : 5));
      if (w.kind === 'snow' || w.kind === 'sleet') return t('advice_snow', { label: LABEL[w.kind], warmth });
      if (w.wet) return t('advice_rain', { warmth });
      if (w.windy) return t('advice_wind', { warmth });
      if (f >= 22) return t('advice_warm');
      return t('advice_default', { temp: deg(f), warmth });
    };

    // Other colours of the same model, from Shopify's predictive search (cached per visit)
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const siblingCache = {};
    const siblings = (model) => {
      if (siblingCache[model]) return siblingCache[model];
      const key = 'se-wx-sib-' + (document.documentElement.lang || '') + '-' + model;
      try {
        const hit = JSON.parse(sessionStorage.getItem(key));
        if (hit) return (siblingCache[model] = Promise.resolve(hit));
      } catch (e) {}
      const url = `${root}search/suggest.json?q=${encodeURIComponent(model)}&resources[type]=product&resources[limit]=10&resources[options][fields]=title`;
      siblingCache[model] = fetch(url)
        .then((r) => (r.ok ? r.json() : null))
        .then((json) => {
          const list = ((json && json.resources && json.resources.results && json.resources.results.products) || [])
            .filter((x) => x.available && x.title.split(' — ')[0].trim() === model)
            .map((x) => ({
              handle: x.handle,
              title: x.title,
              color: x.title.split(' — ').slice(1).join(' — '),
              url: x.url,
              image: (x.featured_image && x.featured_image.url) || x.image || '',
              price: x.price,
            }));
          try { sessionStorage.setItem(key, JSON.stringify(list)); } catch (e) {}
          return list;
        })
        .catch(() => []);
      return siblingCache[model];
    };
    // Solid swatch colour: the median colour of the garment in a small copy of the photo.
    // Background pixels (the grey studio backdrop, sampled from the corner) are ignored, and
    // the median keeps zips, buttons and seams from skewing it. Falls back to a cropped photo
    // if the image can't be read (CORS).
    const colourCache = {};
    const swatchColour = (src) => {
      if (!src) return Promise.resolve(null);
      if (colourCache[src]) return colourCache[src];
      const key = 'se-wx-col-' + src.split('?')[0];
      try {
        const hit = sessionStorage.getItem(key);
        if (hit) return (colourCache[src] = Promise.resolve(hit));
      } catch (e) {}
      colourCache[src] = new Promise((resolve) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
          try {
            const w = 60;
            const h = Math.round((img.naturalHeight / img.naturalWidth) * w) || 90;
            const c = document.createElement('canvas');
            c.width = w;
            c.height = h;
            const ctx = c.getContext('2d', { willReadFrequently: true });
            ctx.drawImage(img, 0, 0, w, h);
            const data = ctx.getImageData(0, 0, w, h).data;
            const bg = [data[8], data[9], data[10]];
            const r = [], g = [], b = [];
            for (let y = Math.floor(h * 0.2); y < h * 0.8; y++) {
              for (let x = Math.floor(w * 0.15); x < w * 0.85; x++) {
                const i = (y * w + x) * 4;
                const d = Math.abs(data[i] - bg[0]) + Math.abs(data[i + 1] - bg[1]) + Math.abs(data[i + 2] - bg[2]);
                if (d < 24 || data[i + 3] < 200) continue;
                r.push(data[i]); g.push(data[i + 1]); b.push(data[i + 2]);
              }
            }
            if (r.length < 20) return resolve(null);
            const med = (a) => a.sort((m, n) => m - n)[a.length >> 1];
            const col = `rgb(${med(r)}, ${med(g)}, ${med(b)})`;
            try { sessionStorage.setItem(key, col); } catch (e) {}
            resolve(col);
          } catch (e) {
            resolve(null);
          }
        };
        img.onerror = () => resolve(null);
        img.src = sized(src, 120);
      });
      return colourCache[src];
    };
    const sized = (src, w) => (src ? src + (src.includes('?') ? '&' : '?') + 'width=' + w : '');
    const money = (amount) => {
      try {
        const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
        return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur }).format(+amount);
      } catch (e) { return amount; }
    };

    class SeWeatherPicks extends HTMLElement {
      /* If the script runs before the parser has reached the cards (cached script, soft navigation),
         wait for the full section instead of failing on missing children. */
      connectedCallback() {
        if (this.started) return;
        if (this.querySelector('[data-se-wx-credit]') || document.readyState !== 'loading') this.init();
        else document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
      }

      init() {
        if (this.started) return;
        this.started = true;
        this.grid = this.querySelector('[data-se-wx-grid]');
        this.items = [...this.grid.children].map((li) => ({
          li,
          min: Math.min(+li.dataset.min, +li.dataset.max),
          max: Math.max(+li.dataset.min, +li.dataset.max),
          water: +li.dataset.water || 0,
          wind: +li.dataset.wind || 0,
          gender: (li.dataset.gender || '').split(',').filter(Boolean),
        }));
        this.count = +this.dataset.count || 4;
        this.countMobile = +this.dataset.countMobile || this.count;
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.thumb = this.querySelector('[data-se-wx-thumb]');
        const progress = () => {
          const g = this.grid;
          const ratio = g.scrollWidth > 0 ? Math.min(1, g.clientWidth / g.scrollWidth) : 1;
          const max = g.scrollWidth - g.clientWidth;
          const pos = max > 0 ? g.scrollLeft / max : 0;
          this.thumb.style.width = ratio * 100 + '%';
          this.thumb.style.transform = 'translateX(' + pos * (1 / ratio - 1) * 100 + '%)';
          this.thumb.parentElement.hidden = ratio >= 0.999;
        };
        this.progress = progress;
        this.grid.addEventListener('scroll', progress, { passive: true });
        window.addEventListener('resize', progress);
        this.gender = store.get(STORE_GENDER) || this.dataset.gender || 'all';

        this.select = this.querySelector('[data-se-wx-city]');
        CITIES.forEach(([key, name]) => this.select.add(new Option(cityName(key, name), key)));
        this.select.addEventListener('change', () => this.setCity(this.select.value, true));

        const locate = this.querySelector('[data-se-wx-locate]');
        if (!('geolocation' in navigator)) locate.hidden = true;
        locate.addEventListener('click', () => this.locate());

        this.querySelectorAll('[data-se-wx-gender]').forEach((b) =>
          b.addEventListener('click', () => {
            this.gender = b.dataset.seWxGender;
            store.set(STORE_GENDER, this.gender);
            this.render();
          })
        );

        const saved = store.get(STORE_CITY);
        if (saved && saved.key === 'here' && saved.lat) {
          this.here = saved;
          this.addHere();
          this.setCity('here');
        } else if (saved && CITIES.some((c) => c[0] === saved.key)) {
          this.setCity(saved.key);
        } else {
          // First visit: always a Scandinavian city. Norway, Sweden and Denmark get their capital;
          // everyone else one of the five big Scandinavian cities.
          const HOME = { NO: 'oslo', SE: 'stockholm', DK: 'copenhagen' };
          const PICKS = ['oslo', 'bergen', 'copenhagen', 'stockholm', 'gothenburg'];
          this.setCity(HOME[this.dataset.country] || PICKS[Math.floor(Math.random() * PICKS.length)]);
          // …unless the browser already lets us use the visitor's location (no prompt is shown)
          navigator.permissions?.query({ name: 'geolocation' }).then((p) => {
            if (p.state === 'granted') this.locate();
          }).catch(() => {});
        }
      }

      addHere() {
        if (this.select.querySelector('option[value="here"]')) return;
        this.select.add(new Option(t('my_location'), 'here'), 0);
      }

      locate() {
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            this.here = { key: 'here', lat: pos.coords.latitude, lon: pos.coords.longitude };
            this.addHere();
            this.setCity('here', true);
          },
          () => {},
          { maximumAge: 3600000, timeout: 10000 }
        );
      }

      place(key) {
        if (key === 'here' && this.here) return { key, name: t('my_location'), lat: this.here.lat, lon: this.here.lon };
        const c = CITIES.find((x) => x[0] === key) || CITIES[0];
        return { key: c[0], name: cityName(c[0], c[1]), lat: c[2], lon: c[3] };
      }

      async setCity(key, remember) {
        const place = this.place(key);
        this.select.value = place.key;
        if (remember) store.set(STORE_CITY, place.key === 'here' ? this.here : { key: place.key });
        this.place_ = place;
        this.weather = await this.forecast(place);
        this.render();
      }

      async forecast(place) {
        const lat = place.lat.toFixed(4);
        const lon = place.lon.toFixed(4);
        const cacheKey = `se-wx-${lat},${lon}`;
        const cached = store.get(cacheKey);
        if (cached && Date.now() - cached.t < CACHE_MIN * 60000) return cached.w;
        try {
          const res = await fetch(`https://api.met.no/weatherapi/locationforecast/2.0/compact?lat=${lat}&lon=${lon}`);
          if (!res.ok) throw new Error(res.status);
          const w = summarise(await res.json());
          if (w) store.set(cacheKey, { t: Date.now(), w });
          return w;
        } catch (e) {
          return null;
        }
      }

      async swatches(li) {
        if (li.dataset.swatched) return;
        li.dataset.swatched = '1';
        const box = li.querySelector('[data-se-wx-swatches]');
        const list = await siblings(li.dataset.model);
        if (list.length < 2) return;
        const current = li.dataset.handle;
        /* One row: at most four colours (always including the one shown), then "+N" */
        const max = 4;
        let shown = list.slice(0, max);
        if (!shown.some((c) => c.handle === current)) {
          const cur = list.find((c) => c.handle === current);
          if (cur) shown = [cur, ...list.filter((c) => c !== cur).slice(0, max - 1)];
        }
        shown.forEach((c) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'se-wx__swatch';
          b.title = c.color;
          b.setAttribute('aria-label', c.color);
          b.setAttribute('aria-pressed', String(c.handle === current));
          swatchColour(c.image).then((col) => {
            if (col) b.style.backgroundColor = col;
            else if (c.image) {
              b.style.backgroundImage = `url("${sized(c.image, 300)}")`;
              b.classList.add('se-wx__swatch--photo');
            }
          });
          b.addEventListener('click', () => this.pick(li, c, box));
          box.appendChild(b);
        });
        if (list.length > max) {
          const more = document.createElement('a');
          more.className = 'se-wx__more';
          more.href = li.querySelector('.se-wx__card').href;
          more.textContent = '+' + (list.length - max);
          box.appendChild(more);
        }
        box.hidden = false;
      }

      pick(li, c, box) {
        const card = li.querySelector('.se-wx__card');
        const img = card.querySelector('img');
        card.href = c.url;
        card.querySelector('.se-wx__name').textContent = c.title;
        if (img && c.image) {
          img.removeAttribute('srcset');
          img.src = sized(c.image, 800);
          img.alt = c.title;
        }
        const price = card.querySelector('[data-se-wx-price]');
        if (price && c.price && Math.round(+c.price * 100) !== +li.dataset.price) price.textContent = money(c.price);
        li.dataset.handle = c.handle;
        box.querySelectorAll('.se-wx__swatch').forEach((b) => b.setAttribute('aria-pressed', String(b.title === c.color)));
      }

      render() {
        const w = this.weather;
        const title = this.querySelector('[data-se-wx-title]');
        const now = this.querySelector('[data-se-wx-now]');
        const adv = this.querySelector('[data-se-wx-advice]');

        this.querySelectorAll('[data-se-wx-gender]').forEach((b) =>
          b.setAttribute('aria-pressed', String(b.dataset.seWxGender === this.gender))
        );

        let list = this.items.filter((p) => this.gender === 'all' || !p.gender.length || p.gender.includes(this.gender));

        if (w) {
          const name = this.place_.name;
          title.textContent = this.place_.key === 'here' ? t('today_here') : t('today_in', { city: name });
          const bits = [deg(w.tNow), LABEL[w.kind]];
          if (w.precip >= 0.3) bits.push(`${w.precip.toFixed(1).replace('.0', '')} mm`);
          bits.push(t('wind', { n: Math.round(w.windMax) }));
          now.textContent = bits.join(' · ');
          adv.textContent = advice(w);
          list = list
            .map((p, i) => ({ p, s: score(p, w), i }))
            .sort((a, b) => a.s - b.s || a.i - b.i)
            .map((x) => x.p);
        } else {
          now.textContent = '';
          adv.textContent = '';
        }

        const show = list.slice(0, this.mobile.matches ? this.countMobile : this.count);
        this.items.forEach((p) => (p.li.hidden = true));
        show.forEach((p) => {
          p.li.hidden = false;
          p.li.querySelector('[data-se-wx-why]').textContent = w ? why(p, w) : '';
          this.grid.appendChild(p.li);
          this.swatches(p.li);
        });
        this.grid.scrollLeft = 0;
        this.classList.add('is-ready');
        requestAnimationFrame(this.progress);
      }
    }

    customElements.define('se-weather-picks', SeWeatherPicks);
  })();

  } catch(e) { console.error(e); }
})();
})();
